// Profile Section Text Content - No hardcoded strings in components
export const PROFILE_TEXT = {
  // Page Title
  PAGE_TITLE: "Settings",
  PAGE_SUBTITLE: "Manage your profile and preferences",

  // Tabs
  TAB_PERSONAL: "My Profile",
  TAB_ACADEMIC: "Academic Info",
  TAB_PREFERENCES: "Preferences",

  // Personal Info Tab
  SECTION_PROFILE_PICTURE: "Profile Picture",
  SECTION_BASIC_INFO: "Basic Information",
  SECTION_LOCATION: "Location & Residency",

  // Academic Tab
  SECTION_ACADEMIC_PLANS: "Academic Plans",
  SECTION_PERFORMANCE: "Academic Performance",

  // Preferences Tab
  SECTION_NOTIFICATIONS: "Notifications",
  SECTION_PRIVACY: "Privacy & Security",

  // Buttons
  BTN_UPLOAD_PHOTO: "Upload Photo",
  BTN_REMOVE: "Remove",
  BTN_SAVE: "Save Changes",
  BTN_SAVING: "Saving...",
  BTN_SAVED: "Saved",
  BTN_FAILED: "Failed to save",
  BTN_BACK: "Back to Dashboard",
  BTN_SIGN_OUT: "Sign Out",
  BTN_VIEW_PROFILE: "View Profile",

  // Field Labels
  LABEL_FIRST_NAME: "First Name",
  LABEL_LAST_NAME: "Last Name",
  LABEL_PREFERRED_NAME: "Preferred Name",
  LABEL_DATE_OF_BIRTH: "Date of Birth",
  LABEL_COUNTRY: "Country",
  LABEL_STATE: "State/Region",
  LABEL_RESIDENCY: "Residency Status",
  LABEL_INTENDED_MAJOR: "Intended Major",
  LABEL_APPLICATION_YEAR: "Application Year",
  LABEL_GPA: "GPA",
  LABEL_SAT: "SAT Score",
  LABEL_ACT: "ACT Score",

  // Placeholders
  PLACEHOLDER_FIRST_NAME: "John",
  PLACEHOLDER_LAST_NAME: "Doe",
  PLACEHOLDER_PREFERRED_NAME: "Johnny",
  PLACEHOLDER_DATE_OF_BIRTH: "YYYY-MM-DD",
  PLACEHOLDER_MAJOR: "e.g., Computer Science",
  PLACEHOLDER_GPA: "3.92",
  PLACEHOLDER_SAT: "1480",
  PLACEHOLDER_ACT: "34",
  PLACEHOLDER_BUDGET: "$50,000",

  // Helper Text
  HELPER_PREFERRED_NAME: "What you'd like to be called (e.g., nickname)",
  HELPER_GPA: "Unweighted GPA on 4.0 scale",
  HELPER_SAT: "Out of 1600",
  HELPER_ACT: "Out of 36",

  // Notifications
  NOTIF_EMAIL: "Email notifications",
  NOTIF_EMAIL_DESC: "Receive updates and reminders via email",

  // Privacy Options
  PRIVACY_PASSWORD: "Change Password",

  // Loading & Errors
  LOADING: "Loading profile...",
  ERROR_GENERIC: "Unable to load profile. Please try again.",
  ERROR_SAVE: "Unable to save changes. Please try again.",
} as const;

// Dropdown Options - Comprehensive country list
export const COUNTRIES = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "East Timor",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Ivory Coast",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kosovo",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
] as const;

export const US_STATES = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
] as const;

export const RESIDENCY_STATUS = [
  "U.S. Citizen",
  "U.S. Permanent Resident (Green Card holder)",
  "Dual Citizen",
  "International Student",
  "Non-U.S. Citizen (Other / Undocumented, incl. DACA)",
] as const;

export const APPLICATION_YEARS = [
  2030, 2031, 2032, 2033, 2034, 2035, 2036, 2037, 2038, 2039, 2040,
] as const;

// Validation Constants
export const VALIDATION = {
  MIN_AGE: 13,
  MAX_AGE: 25,
  MIN_GPA: 0,
  MAX_GPA: 4.0,
  MIN_SAT: 400,
  MAX_SAT: 1600,
  MIN_ACT: 1,
  MAX_ACT: 36,
  MIN_BUDGET: 0,
} as const;
